var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[(_vm.visible)?_c('div',{staticClass:"sider"},[_vm._t("default"),_c('button',{on:{"click":function($event){_vm.visible=false}}},[_vm._v("close")])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }